module.exports = __webpack_public_path__ + "img/trunk_4x1_z16.b726864b.svg";